import FetchWorkflowCatalog from '@Application/Organizations/Workflows/Queries/FetchWorkflowCatalog';
import fetchWorkflowCatalog from '@Application/Organizations/Workflows/fetchWorkflowCatalog';
import type WorkflowCatalogView from '@UI/Store/OrganizationWorkflows/Views/WorkflowCatalogView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

type UseWorkflowCatalogResult = {
	catalog: WorkflowCatalogView | null;
	error: Error | null;
	refetch: () => void;
};

/** The global preset catalogue: fetched once, shared by every account. */
function useWorkflowCatalog(): UseWorkflowCatalogResult {
	const dispatch = useDispatch();

	const { data, error, refetch } = useStoreQuery({
		selector: (state) => state.organizationWorkflowsStore.catalog,
		stopOn: (value) => value !== null,
		query: () => dispatch(fetchWorkflowCatalog(new FetchWorkflowCatalog())),
		deps: [],
	});

	return { catalog: data, error, refetch };
}

export default useWorkflowCatalog;
